import React from 'react';

const Header = () => {
    return (
        <div className="py-7 px-4 mb-0 mt-6 text-center header-form-wrap">
            <img src="/logo.png" width={150} alt="Logo" className="img-fluid" />
        </div>
    );
};

export default Header;